<script setup>

</script>

<template>
  <!--begin::sidebar menu-->
  <div class="app-sidebar-menu overflow-hidden flex-column-fluid">
    <!--begin::Menu wrapper-->
    <div id="kt_app_sidebar_menu_wrapper" class="app-sidebar-wrapper">
      <!--begin::Scroll wrapper-->
      <div
        id="kt_app_sidebar_menu_scroll"
        class="scroll-y my-5 mx-3"
        data-kt-scroll="true"
        data-kt-scroll-activate="true"
        data-kt-scroll-height="auto"
        data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer"
        data-kt-scroll-wrappers="#kt_app_sidebar_menu"
        data-kt-scroll-offset="5px"
        data-kt-scroll-save-state="true"
      >
        <!--begin::Menu-->
        <div
          class="menu menu-column menu-rounded menu-sub-indention fw-semibold fs-6"
          id="#kt_app_sidebar_menu"
          data-kt-menu="true"
          data-kt-menu-expand="false"
        >

          <div class="menu-item">
            <Link class="menu-link" href="/admin">
              <span class="menu-icon"><i class="bi bi-speedometer2 fs-2"></i></span>
              <span class="menu-title">Dashboard</span>
            </Link>
          </div>

          <div class="menu-item">
            <Link class="menu-link" :href="route('user-medias.index')" :only="['flash','user_medias']">
              <span class="menu-icon"><i class="bi bi-images fs-2"></i></span>
              <span class="menu-title">Medya Kütüphanem</span>
            </Link>
          </div>

          <div class="menu-item pt-5">
            <div class="menu-content">
              <span class="menu-heading fw-bold text-uppercase fs-7">FOTOĞRAF YÖNETİMİ</span>
            </div>
          </div>

          <div class="menu-item">
            <Link class="menu-link" :href="route('my.photos',{language:$page.props.current_language})" :only="['flash','photos','filters']">
              <span class="menu-icon"><i class="bi bi-images fs-2"></i></span>
              <span class="menu-title">Fotoğraflarım</span>
            </Link>
          </div>

          <div class="menu-item">
            <Link class="menu-link" :href="route('photos.create',{language:$page.props.current_language})">
              <span class="menu-icon"><i class="bi bi-image fs-2"></i></span>
              <span class="menu-title">Fotoğraf Ekle</span>
            </Link>
          </div>

        </div>
        <!--end::Menu-->
      </div>
      <!--end::Scroll wrapper-->
    </div>
    <!--end::Menu wrapper-->
  </div>
  <!--end::sidebar menu-->
</template>